export default {
    pinMamagement: 'PIN Management',
    searchBy: 'Search by Employee No or Name',
    search: 'Search',
    name: 'Full Name',
    employeeNo: 'Employee No',
    pinStatus: 'PIN Status',
    reset: 'Reset'
}
